import { useLayoutElementsResponse } from "@faire/deprecated-retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/LayoutElements/__internal__/useLayoutElementsResponse";
import {
  isValidForPage,
  isValidForPlatform,
} from "@faire/deprecated-retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/Base/__internal__/LayoutElements/__internal__/utils/layoutElementFilterUtils";
import { useOneIndexedPageNumber } from "@faire/deprecated-retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedInCategoryPage/__internal__/useOneIndexedPageNumber";
import { ILayoutElement } from "@faire/web-api--source/indigofair/data/ILayoutElement";
import { useViewport } from "@faire/web/common/hooks/useViewport";
import { useCallback, useMemo } from "react";

export const useGetCategoryPageLayoutElementsByPlacement = () => {
  const { data } = useLayoutElementsResponse();
  const { isMobile } = useViewport();
  const pageNumber = useOneIndexedPageNumber();
  const layoutElements = useMemo(() => data?.layout_elements ?? [], [data]);

  return useCallback(
    (placement: ILayoutElement.Placement) => {
      return layoutElements
        .filter(
          // c1 homepage has placement TOP stored in db which couldn't easily migrate to BELOW_TITLE
          // add special handling here to include TOP placement when we filter BELOW_TITLE placement
          (layoutElement) =>
            layoutElement.placement === placement ||
            (placement === ILayoutElement.Placement.BELOW_TITLE &&
              layoutElement.placement === ILayoutElement.Placement.TOP)
        )
        .filter(
          (layoutElement) =>
            isValidForPlatform(layoutElement, isMobile) &&
            isValidForPage(layoutElement, pageNumber)
        );
    },
    [layoutElements, isMobile, pageNumber]
  );
};
